import { render, staticRenderFns } from "./NestedDragTab.vue?vue&type=template&id=20772f21&scoped=true"
import script from "./NestedDragTab.vue?vue&type=script&lang=js"
export * from "./NestedDragTab.vue?vue&type=script&lang=js"
import style0 from "./NestedDragTab.vue?vue&type=style&index=0&id=20772f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20772f21",
  null
  
)

export default component.exports